import { useState, useEffect, memo } from 'react';
import type { FC } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import NotificationsIcon from '@mui/icons-material/Notifications';
import useNotification from 'src/hooks/useNotifications';
import NotificationsBody from './NotificationsBody';
import { getPastDueTasks, getTasksDueToday } from './NotificationsLogic';
import 'src/theme/partials/notifications/NotificationsBase.css';
import 'src/theme/partials/notifications/NotificationsModal.css';
import useSettings from 'src/hooks/useSettings';

const NotificationsModal: FC<React.PropsWithChildren> = () => {
  const { tasksInNotificationRange, hasModalAlreadyOpened, setHasModalAlreadyOpened, pauseFor24Hours, isNotificationPaused } = useNotification();
  const notificationModalEnabled = useSettings((state) => state.settings.notificationModalEnabled);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [iconTotal, setIconTotal] = useState<number>(0);

  useEffect(() => {
    if (!notificationModalEnabled || hasModalAlreadyOpened || isNotificationPaused()) {
      //Dont show the modal
      return;
    }

    let total = getPastDueTasks(tasksInNotificationRange).length + getTasksDueToday(tasksInNotificationRange).length;

    if (total > 0) {
      setModalOpen(true);
      setIconTotal(total);
      setHasModalAlreadyOpened(true);
    }
  }, [tasksInNotificationRange, hasModalAlreadyOpened, isNotificationPaused, notificationModalEnabled]);

  const pauseNotificationsClicked = () => {
    pauseFor24Hours();
    setModalOpen(false);
    setHasModalAlreadyOpened(true);
  };

  return (
    <Dialog open={modalOpen} fullWidth maxWidth="sm" className="notifications-modal">
      <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }} className="notifications-modal__title">
        <NotificationsIcon />({iconTotal}) Tasks Due
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ display: 'flex', justifyContent: 'center' }} className="notifications-modal__content">
        <Box sx={{ textAlign: 'center' }}>
          <NotificationsBody />
          <Button color="primary" variant="contained" onClick={() => setModalOpen(false)}>
            Close
          </Button>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ display: 'flex', justifyContent: 'space-around' }} className="notifications__btns">
        <Box>
          <Button color="primary" variant="text" onClick={() => setModalOpen(false)}>
            <Link to="/account/settings">Notification Settings</Link>
          </Button>
          <Button color="primary" variant="text" onClick={pauseNotificationsClicked}>
            <Link to={'#'}>Snooze Notifications for 24 hours</Link>
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default memo(NotificationsModal);
